import React, { useContext, useEffect, useState } from "react"
import PendLoansComp from "../Loan/PendingLoans"
import RejLoansComp from "../Loan/RejectedLoans"
import RefferedLoans from "../Loan/RefferedLoans"
import DisLoansComp from "../Loan/DisbursedLoans"
import TabHeader from "../TabHeader"
// import ApprovedLoanTable from "../Loan/ApprovedLoans/ApprovedLoansTable"
import { AuthContext } from "context/AuthContext"
import { useSearchParams } from "react-router-dom"
import ApprovedLoans from "../Loan/ApprovedLoans"

const tabs = [
	{label:"Pending",index:1},
	{label:"Reffered",index:2},
	{label:"Disbursed",index:3},
	{label:"Approved",index:4},
	{label:"Rejected",index:5},
]

export function TabContent({currentTab}){
	const {userProfile} = useContext(AuthContext)

	const adminRole = userProfile?.admin_role

	if(currentTab === 1) return <PendLoansComp />;
	if(currentTab === 2){
		return <RefferedLoans admin_role={adminRole} user={userProfile}/>
    }
	if(currentTab === 3) return <DisLoansComp/>;
	if(currentTab === 4) return <ApprovedLoans/>;
	return <RejLoansComp />

}

export default function LoanOfficerTabs() {
	const [toggleState, setToggleState] = useState(1)
	
		const [params,setParams] = useSearchParams()
	
		const handleSetTab = (tab)=>{
			setParams({tab})
			setToggleState(tab)
		}
	
		useEffect(()=>{
			const currentTab = params.get("tab")
			if(currentTab){
				setToggleState(parseInt(currentTab))
			}
		},[params])

	return (
		<section>
			<TabHeader tabs={tabs} selectTab={handleSetTab} currentTab={toggleState}/>
			<div className="mt-4">
				<TabContent currentTab={toggleState}/>
			</div>
		</section>
	)
}

